import bind from 'bind-decorator';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

export interface ClinicalBaseControlProps {
  onSelectNext: () => void;
}
const ClinicalBaseControl = <T extends ClinicalBaseControlProps>(
  WrappedComponent: React.ComponentType<T>
) => {
  type u = Omit<T, keyof ClinicalBaseControlProps>;
  class WrapperClinicalControl extends React.Component<u> {
    _refs = {
      wrappedComponent: React.createRef<typeof WrappedComponent>()
    };

    focus() {
      const current = this._refs.wrappedComponent.current as any;

      current?._refs?.input?.current?.focus();
    }

    @bind
    onSelectNext() {
      const el = ReactDOM.findDOMNode(this);
      const $els = $(el).parents('.clinical-page-content').find('.clinical-control').toArray();

      const index = $els.indexOf(el);
      if ($els.length > index)
        $($els[index + 1])
          .find('[tabIndex]')
          .focus();
    }

    render() {
      return (
        <span className="clinical-control">
          <WrappedComponent
            ref={this._refs.wrappedComponent}
            tabIndex={0}
            {...(this.props as T)}
            onSelectNext={this.onSelectNext}
          />
        </span>
      );
    }
  }

  return WrapperClinicalControl;
};
export { ClinicalBaseControl };
export default ClinicalBaseControl;
